import {
  AutotradeTrigger,
  CreateTriggerPayload,
  UpdateTriggerPayload,
} from '@crypto-trading/common/browser';
import { ApiClientManager } from '@/utils/api-client-factory';

export const listTriggers = async (
  userId: string
): Promise<AutotradeTrigger[]> => {
  if (!userId) return [];
  return ApiClientManager.getTriggerClient().listTriggers(userId);
};

export const createTrigger = async (
  userId: string,
  payload: CreateTriggerPayload
): Promise<AutotradeTrigger> => {
  return ApiClientManager.getTriggerClient().createTrigger(userId, payload);
};

export const updateTrigger = async (
  triggerId: string,
  userId: string,
  payload: UpdateTriggerPayload
): Promise<AutotradeTrigger> => {
  return ApiClientManager.getTriggerClient().updateTrigger(
    triggerId,
    userId,
    payload
  );
};

export const deleteTrigger = async (
  triggerId: string,
  userId: string
): Promise<void> => {
  return ApiClientManager.getTriggerClient().deleteTrigger(triggerId, userId);
};
